<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域font-family:Consolas-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Logistic</el-breadcrumb-item>
    <el-breadcrumb-item>Deliveries</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <el-row>
          <el-col :span = "6">
      <el-form-item label="Internal ID:" label-width="115px">
        <el-input v-model="formInline.internalId" placeholder="Internal ID" clearable></el-input>
      </el-form-item>
</el-col>
<el-col :span = "6">
      <el-form-item label="Product:" label-width="100px">
        <el-input v-model="formInline.product" placeholder="Product" clearable></el-input>
      </el-form-item>
      </el-col>
      <el-col :span = "12">
        <el-form-item label="Loading Date:" label-width="135px" style="margin-left: 20px;">
          <el-date-picker
                v-model="formInline.loadDate"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
        </el-col>
      </el-row>

      <el-row>
                <el-col :span = "6">
            <el-form-item label="Brand:" label-width="115px">
              <el-select v-model="formInline.brands" multiple collapse-tags
                    style="margin-left: 0px;" filterable
                    placeholder="please choose">
                  <el-option
                  v-for="item in this.brandList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
      </el-col>
      <el-col :span = "6">
            <el-form-item label="Project:" label-width="100px">
              <el-input v-model="formInline.project" placeholder="Project" clearable></el-input>
            </el-form-item>
            </el-col>
            <el-col :span = "7">
              <el-form-item label="Project N.:" label-width="135px" style="margin-left: 20px;">
                <el-input v-model="formInline.sectionAna" placeholder="Project N." clearable></el-input>
                </el-form-item>
              </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
          <el-form-item label="Container:" label-width="115px">
            <el-input v-model="formInline.container" placeholder="Container" clearable></el-input>
          </el-form-item>
          </el-col>
        <el-col :span = "6">
          <el-form-item label="Desc.:" label-width="100px">
            <el-input v-model="formInline.description" placeholder="Desc." clearable></el-input>
          </el-form-item>
          </el-col>
          <el-col :span = "7">
            <el-form-item label="Cust Order Ref:" label-width="135px"  style="margin-left: 20px;">
              <el-input v-model="formInline.custOrderRef" placeholder="Customer Order Ref" clearable></el-input>
            </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
          <el-form-item label="Vessel Name:" label-width="115px">
            <el-input v-model="formInline.vesselName" placeholder="Vessel Name" clearable></el-input>
          </el-form-item>
          </el-col>
        <el-col :span = "6">
          <el-form-item label="Seal N.:" label-width="100px">
            <el-input v-model="formInline.seal" placeholder="Seal N." clearable></el-input>
          </el-form-item>
          </el-col>
          <el-col :span = "7">
            <el-form-item label="PL N.(long):" label-width="135px"  style="margin-left: 20px;">
              <el-input v-model="formInline.plnLong" placeholder="PL N.(long)" clearable></el-input>
            </el-form-item>
        </el-col>
      </el-row>
        <div v-if="this.userName.toUpperCase()!=='IP' && this.userName.toUpperCase()!=='IPIT' && this.userName.toUpperCase()!=='HBG'">
          <el-row>
           <el-col :span = "6">
          <el-form-item label="Sold To:" label-width="115px">
                <el-select v-model="formInline.soldTos" multiple collapse-tags
                  style="margin-left: 0px;"
                  placeholder="please choose">
                <el-option
                v-for="item in this.soldToArr"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
            <el-col :span = "12">
            <el-form-item style="margin-left: 136px;">
              <el-button type="primary" @click="onSubmit" id="searchId">Search</el-button>
              <el-button type="primary" @click="exportToExcel">Excel</el-button>
            </el-form-item>
            </el-col>
          </el-row>
          </div>
          <div v-else>
          <el-row>
            <el-col>
            <el-form-item style="margin-left: 450px;">
              <el-button type="primary" @click="onSubmit" id="searchId">Search</el-button>
              <el-button type="primary" @click="exportToExcel">Excel</el-button>
            </el-form-item>
            </el-col>
          </el-row>
          </div>
    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="deliveryList" border stripe style="width: 100%">
        <el-table-column type="index" label="#" fixed></el-table-column>
            <el-table-column   fixed
              prop="loadDate"
              label="Loading date" :formatter="dateFormat"
              width="105">
            </el-table-column>
            <el-table-column   fixed
              prop="internalId"
              label="Internal ID"
              width="120">
            </el-table-column>

            <el-table-column  fixed
              prop="product"
              label="Product"   :show-overflow-tooltip="true"
              width="90">
            </el-table-column>

            <el-table-column   fixed
              prop="description"
              label="Description" :show-overflow-tooltip="true"
              width="150">
            </el-table-column>

            <el-table-column   fixed
              prop="custOrderRef"
              label="Customer order ref "
              width="150">
            </el-table-column>

            <el-table-column
              prop="plnLong"                   sortable
              label="PL N.(long)"
              width="125">
            </el-table-column>

            <el-table-column
              prop="plnShort"
              label="PL N.(short)"
              width="110">
            </el-table-column>

            <el-table-column
              prop="etd"
              label="ETD"
              width="95" :formatter="dateFormat">
            </el-table-column>

            <el-table-column
              prop="eta"
              label="ETA" :formatter="dateFormat"
              width="95">
            </el-table-column>

            <el-table-column
              prop="deliveredQty"
              label="Delivered quantity"  :formatter="numFormat"
              width="150">
            </el-table-column>

            <el-table-column
              prop="deliveredType"
              label="Delivery Type"
              width="110">
            </el-table-column>

            <el-table-column
              prop="containerType"
              label="Container type"
              width="120">
            </el-table-column>

            <el-table-column
              prop="container"             sortable
              label="Container"
              width="110">
            </el-table-column>

            <el-table-column
              prop="vesselName"             sortable
              label="Vessel Name" :show-overflow-tooltip="true"
              width="150">
            </el-table-column>

            <el-table-column
              prop="seal"         sortable
              label="Seal N."
              width="99">
            </el-table-column>

            <el-table-column
              prop="comment"
              label="Comment" :show-overflow-tooltip="true"
              width="79">
            </el-table-column>

            <el-table-column
              prop="brand"
              label="Brand"
              width="79">
            </el-table-column>

            <el-table-column
              prop="project"
              label="Project" :show-overflow-tooltip="true"
              width="190">
            </el-table-column>

            <el-table-column
              prop="sectionAna"
              label="Project N."
              width="120">
            </el-table-column>

            <el-table-column
              prop="soldTo"
              label="Sold to"
              width="79">
            </el-table-column>

            <el-table-column
              prop="ffId"
              label="FF Id"
              width="120">
            </el-table-column>

            <el-table-column
              prop="cargoId"
              label="Cargo ID"
              width="170">
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size.sync="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        loadDate: '',
        internalId: '',
        product: '',
        brands: [],
        project: '',
        container: '',
        sectionAna: '',
        description: '',
        vesselName: '',
        seal: '',
        plnLong: '',
        soldTos: [],
        custOrderRef: '',
        token: '',
        page: 1,
        rows: 100
      },
      brandList: [],
      brandParam: {
        userName: '',
        userType: ''
      },
      deliveryList: [],
      total: 0,
      updateTime: '',
      userName: '',
      isHandleCurrentChange: true,
      soldToArr: ['IP', 'OMC', 'CSP', 'HORIZONB', 'OWILD', 'SDPP', 'JEN', 'LASH', 'TSM', 'OSEE', 'BUBBLE', 'GOTHA', 'TSMT', 'SAP', 'DIJO', 'TBY', 'EXERTIER', 'NPS', 'HERON', 'J3P', 'PPI', 'ESF', 'IPIT']
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getDeliveries()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getDeliveries()
    },
    exportToExcel () {
      var loadDateStart = ''
      var loadDateEnd = ''
      if (this.formInline.loadDate && this.formInline.loadDate.length) {
        loadDateStart = this.formInline.loadDate[0]
        loadDateEnd = this.formInline.loadDate[1]
        this.formInline.loadDate = [...this.formInline.loadDate].join(',')
      }
      /* 表示在当前页面打开新地址 */
      window.open('https://www.myirequest.com:8081/show/exportDelivery?token=' +
      encodeURIComponent(this.formInline.token) +
      '&loadDate=' + this.formInline.loadDate + '&internalId=' + this.formInline.internalId +
      '&product=' + this.formInline.product + '&brand=' + this.formInline.brands +
      '&project=' + this.formInline.project + '&sectionAna=' + this.formInline.sectionAna +
      '&container=' + this.formInline.container +
      '&description=' + this.formInline.description +
      '&vesselName=' + this.formInline.vesselName +
      '&seal=' + this.formInline.seal +
      '&plnLong=' + this.formInline.plnLong +
      '&soldTos=' + this.formInline.soldTos +
      '&custOrderRef=' + this.formInline.custOrderRef, '_parent')
      this.$set(this.formInline, 'loadDate', [loadDateStart, loadDateEnd])
    },
    async getDeliveries () {
      var brandsStr = ''
      var loadDateStart = ''
      var loadDateEnd = ''
      if (this.formInline.loadDate && this.formInline.loadDate.length) {
        loadDateStart = this.formInline.loadDate[0]
        loadDateEnd = this.formInline.loadDate[1]
        this.formInline.loadDate = [...this.formInline.loadDate].join(',')
      }
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      var soldToStr = ''
      if (this.formInline.soldTos && this.formInline.soldTos.length) {
        this.formInline.soldTos = [...this.formInline.soldTos].join(',')
        soldToStr = this.formInline.soldTos
      }
      const { data: res } = await this.$http.get('/show/deliveryList', { params: this.formInline })
      this.deliveryList = res.rows
      this.total = res.total

      if (res.rows && this.deliveryList[0]) {
        this.updateTime = this.deliveryList[0].createTime
      }

      this.$set(this.formInline, 'loadDate', [loadDateStart, loadDateEnd])
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      if (soldToStr !== '') {
        await this.$set(this.formInline, 'soldTos', soldToStr.split(','))
      }
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' ||
        daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date、
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()

      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0
      numrc = (numrc || 0).toString()

      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      if (this.total / val < this.formInline.page) {
        this.isHandleCurrentChange = false
      }
      this.getDeliveries()
    },
    handleCurrentChange (val) {
      if (this.isHandleCurrentChange === true) {
        console.log(`当前页: ${val}`)
        this.formInline.page = val
        this.getDeliveries()
      }
      this.isHandleCurrentChange = true
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    }

    // dateFormat (value) {
    //   if (value === null || value === '') {
    //     return ''
    //   }
    //   var date = new Date(value) // long转换成date
    //   var year = date.getFullYear().toString()
    //   var month = (date.getMonth() + 1)
    //   var day = date.getDate().toString()
    //   if (month < 10) {
    //     month = '0' + month
    //   }
    //   if (day < 10) {
    //     day = '0' + day
    //   }
    //   return year + '/' + month + '/' + day
    // }
  }
}
</script>

<style>
  #productId {
    margin-left: 50px;
  }
  #interId {
    margin-left: 20px;
  }
  #loadDtId {
    margin-left: 90px;
  }
  /* #searchId {
    margin-left: 100px;
  } */

</style>
